import { render, staticRenderFns } from "./EmploymentInformationReview.vue?vue&type=template&id=48d6bb52&"
import script from "./EmploymentInformationReview.vue?vue&type=script&lang=js&"
export * from "./EmploymentInformationReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports